import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetch } from "../../../redux/actions/index";
import { ROOT_URL, SINGLETONS, GETKEYS } from "../../../config";
import { Helmet } from "react-helmet";
import Footer from "../../../router/footer";

const Impressum = props => {
  const impressumData = useSelector(state => state.impressum);
  const dispatch = useDispatch();

  useEffect(() => {
    if (impressumData.empty) {
      dispatch(
        fetch(
          "fetch_impressum",
          `${ROOT_URL + SINGLETONS}impressum?token=${GETKEYS}`
        )
      );
    }
  });

  return (
    <>
      <div
        className="container-big"
        style={{
          borderRight: "1px solid #1a5f38",
          borderLeft: "1px solid #1a5f38"
        }}
      >
        <Helmet>
          <title>
            präzise - persönlich - flexibel | Rechtsanwalt Flechtner |
            Impressum{" "}
          </title>
          <link rel="canonical" href={window.location.origin + "/impressum"} />
        </Helmet>
        <div className="container mainContainer">
          <h1 className="primary large break-word-medium">Impressum</h1>
        </div>
        <div
          className="container datenschutz list"
          dangerouslySetInnerHTML={{ __html: impressumData.text }}
        ></div>
      </div>
      <Footer />
    </>
  );
};

export default Impressum;
